const DEVICE_ID_KEY = 'nightshift:device-id:v1';
let memoryId: string | null = null;

/**
 * A random, browser-local identifier sent when creating or joining a room.
 * Race control only stores a salted hash of it, which lets a host ban a
 * browser without accounts. Clearing site data issues a new one.
 */
export function browserDeviceId(): string {
  if (memoryId) return memoryId;
  try {
    const stored = localStorage.getItem(DEVICE_ID_KEY);
    if (stored && /^[a-zA-Z0-9_-]{16,64}$/.test(stored)) {
      memoryId = stored;
      return stored;
    }
  } catch {
    // Private mode: fall back to a per-tab identity below.
  }
  const bytes = new Uint8Array(18);
  crypto.getRandomValues(bytes);
  memoryId = [...bytes].map((byte) => byte.toString(16).padStart(2, '0')).join('');
  try {
    localStorage.setItem(DEVICE_ID_KEY, memoryId);
  } catch {
    // The identifier still works for this session.
  }
  return memoryId;
}
